import {} from "./data.js";
/** Get the ID from item data. */
export function getItemID({ id }) {
    return id;
}
/** Get the IDs of an iterable set item data. */
export function* getItemIDs(entities) {
    for (const { id } of entities)
        yield id;
}
/** Merge an ID into a set of data to make an `ItemData` */
export function getItem(id, data) {
    return data.id === id ? data : { ...data, id };
}
export function getItemQuery(id) {
    return { id, $limit: 1 };
}
